import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { useCopyAPIKeyIntegration } from '../CopyAPIKeyModal/useCopyAPIKeyIntegration';
import IntegrationCard from '../IntegrationCard/IntegrationCard';
import MondayLogo from './MondayLogo';
export const GetMondayCardTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            MondayCardTID: {
                Connect: 'monday-card-connect'
            }
        }
    });
export default function MondayCard() {
    const { t: mondayComTexts } = useLocaleKeys('integrations.availableApps.mondayCom');
    const { t: sharedTexts } = useLocaleKeys('integrations.availableApps.shared');
    const { showCopyAPIKeyModal } = useCopyAPIKeyIntegration('monday');
    const { MondayCardTID } = useMemo(()=>GetMondayCardTID(), []);
    return /*#__PURE__*/ _jsx(IntegrationCard, {
        testId: "monday-card",
        icon: /*#__PURE__*/ _jsx(MondayLogo, {}),
        title: mondayComTexts.title(),
        subTitle: mondayComTexts.subTitle(),
        mainAction: /*#__PURE__*/ _jsx(IntegrationCard.MainActionButton, {
            bi: {
                name: 'connect_monday'
            },
            onClick: showCopyAPIKeyModal,
            testId: MondayCardTID.Connect(),
            children: sharedTexts.connectButton()
        })
    });
}
